/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable complexity */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Modal, ModalBody } from 'components/modal'
import { numberToCurrency } from 'lib/money'
import { formatStoreNameToIconName } from 'components/icons'
import Link from 'components/link'
import Image from 'components/image'
import useWindowSize from 'lib/hooks/useWindowSize'
import truncate from 'lodash/truncate'
import { AddToBabylistCartButton } from '../../shop-registry/components/buttons/add-to-babylist-cart-button'
import { ExternalStoreBuyButton } from '../../shop-registry/components/buttons/external-store-buy-button'
import List from '../List'
import ListItem from '../ListItem'
import css from './product-offers-modal.scss'

const ProductOfferShape = {
  price: PropTypes.number.isRequired,
  storeName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}

const ProductOffer = ({ price, storeName, url }) => {
  const storeIconName = formatStoreNameToIconName(storeName)

  return (
    <Link
      className={classNames(
        css.productOffer,
        'btn-pill offer-layout-wrapper mbm prl flex align-center'
      )}
      url={url}
      newWindow
    >
      <span
        className={classNames(
          'icon-offer',
          `icon-offer-${storeIconName}`,
          'mrm'
        )}
      />
      <span className="h6 man flex-grow">
        {price
          ? `${numberToCurrency(price)} at ${storeName}`
          : `Available at ${storeName}`}
      </span>
      <i className="fa fa-chevron-right h7" />
    </Link>
  )
}

ProductOffer.propTypes = ProductOfferShape

function OfferButton({
  affiliateUrl,
  dismissModal,
  isBabylist,
  productId,
  regItemId,
  storeName,
  url,
  isMobile,
  openRedirectModal,
  viglinkEnabled,
}) {
  const size = isMobile && 'small'
  const sharedStyles = { width: isMobile ? 100 : 135, height: isMobile && 33 }
  const otherProps = { style: sharedStyles, size, className: 'mls' }

  if (isBabylist || storeName === 'babylist.com' || storeName === 'Babylist') {
    return (
      <AddToBabylistCartButton
        quantity={1}
        productId={productId}
        onClick={dismissModal}
        {...otherProps}
      />
    )
  }

  return (
    <ExternalStoreBuyButton
      url={affiliateUrl || url}
      openRedirectModal={openRedirectModal}
      storeDisplayName={storeName}
      viglinkEnabled={viglinkEnabled}
      {...otherProps}
    />
  )
}

OfferButton.propTypes = {
  affiliateUrl: PropTypes.string.isRequired,
  dismissModal: PropTypes.func,
  isBabylist: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  productId: PropTypes.number.isRequired,
  regItemId: PropTypes.number,
  storeName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  openRedirectModal: PropTypes.func.isRequired,
  viglinkEnabled: PropTypes.bool.isRequired,
}

OfferButton.defaultProps = {
  dismissModal: undefined,
  regItemId: undefined,
}

function trimText(text, width) {
  // iPhone SE
  if (width > 320 && width <= 375 && text.length >= 21) {
    return truncate(text, { length: 22 })
  }

  // iPhone 8
  if (width <= 320 && text.length >= 14) {
    return truncate(text, { length: 16 })
  }

  return text
}

export const ProductOffersBody = ({
  brand,
  imageUrl,
  name,
  offers,
  openRedirectModal,
  productId,
  regItemId,
  dismissModal,
  isMobile,
}) => {
  const { width } = useWindowSize()

  return (
    <>
      <div className="flex mbl">
        {/* Wrapping this element with a `div` fixes a bug that only occurs in Safari, where it won't automatically scale the image height. */}
        <div>
          <Image
            className="img-responsive media-left"
            src={imageUrl}
            width={150}
            alt={name}
          />
        </div>
        <div className="flex col">
          {brand && (
            <div className="text-brand-info text-bold man h6">{brand}</div>
          )}
          <div className="man h5">{name}</div>
        </div>
      </div>

      <List>
        {offers.map((offer) => {
          const urlPath = window.location.pathname
          const iconSize = isMobile ? '' : '-lg'
          const storeName = offer.storeDisplayName || offer.storeName
          const offerDescription = offer.price
            ? `${numberToCurrency(offer.price)} at ${storeName}`
            : `Available at ${storeName}`
          const url = offer.affiliateUrl || offer.url
          const shouldOpenModal =
            openRedirectModal &&
            !offer.isBabylist &&
            storeName !== 'babylist.com' &&
            storeName !== 'Babylist'
          const handleClick = () => {
            openRedirectModal({
              url,
              storeDisplayName: storeName,
              isShopRegistryView: true,
            })
          }

          return urlPath === '/registry/shop' ? (
            <ListItem key={url} variant="outlined">
              <div
                className={classNames('flex center space-between pam-md', {
                  pas: isMobile,
                })}
              >
                <Link
                  className={css.productOfferLink}
                  newWindow={shouldOpenModal ? undefined : true}
                  url={shouldOpenModal ? undefined : url}
                  onClick={shouldOpenModal ? handleClick : undefined}
                >
                  <div className="flex align-center">
                    <span
                      className={classNames(
                        'icon-offer'.concat(iconSize),
                        `icon-offer-${formatStoreNameToIconName(
                          storeName
                        )}`.concat(iconSize)
                      )}
                    />
                  </div>
                  <span
                    className={classNames('h6', {
                      mam: !isMobile,
                      mas: isMobile,
                    })}
                  >
                    {trimText(offerDescription, width)}
                  </span>
                </Link>
                <div>
                  <OfferButton
                    {...offer}
                    dismissModal={dismissModal}
                    isMobile={isMobile}
                    productId={productId}
                    regItemId={regItemId}
                    storeName={storeName}
                    openRedirectModal={openRedirectModal}
                    viglinkEnabled={offer.viglinkEnabled}
                  />
                </div>
              </div>
            </ListItem>
          ) : (
            <ListItem key={url} variant="outlined">
              <Link
                style={{ color: 'inherit', display: 'block' }}
                className={classNames({
                  'pts pbs plm prm': isMobile,
                  pam: !isMobile,
                })}
                newWindow
                url={offer.affiliateUrl || offer.url}
              >
                <div className={classNames('flex space-between align-center')}>
                  <div className={classNames('flex')}>
                    <div className="flex align-center">
                      <span
                        className={classNames(
                          'icon-offer'.concat(iconSize),
                          `icon-offer-${formatStoreNameToIconName(
                            storeName
                          )}`.concat(iconSize)
                        )}
                      />
                    </div>
                    <span
                      className={classNames('h6', {
                        mam: !isMobile,
                        mas: isMobile,
                      })}
                    >
                      {trimText(offerDescription, width)}
                    </span>
                  </div>
                  <div
                    className={classNames({ mrs: isMobile, mrm: !isMobile })}
                  >
                    <i className="fa fa-chevron-right h7" />
                  </div>
                </div>
              </Link>
            </ListItem>
          )
        })}
      </List>

      <div className={classNames(css.disclaimer, 'mtl h7')}>
        Retailers may offer multiple product style options.
      </div>
    </>
  )
}

ProductOffersBody.propTypes = {
  brand: PropTypes.string,
  dismissModal: PropTypes.func,
  imageUrl: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  offers: PropTypes.arrayOf(PropTypes.shape(ProductOfferShape)).isRequired,
  openRedirectModal: PropTypes.func,
  productId: PropTypes.number,
  regItemId: PropTypes.number,
}

ProductOffersBody.defaultProps = {
  brand: undefined,
  dismissModal: undefined,
  openRedirectModal: null,
  productId: undefined,
  regItemId: undefined,
}

export const ProductOffersModal = ({
  brand,
  imageUrl,
  name,
  offers,
  onHide,
  show,
}) => {
  return (
    <Modal show={show} onHide={onHide} title="Buying Options">
      <ModalBody>
        <ProductOffersBody
          brand={brand}
          imageUrl={imageUrl}
          name={name}
          offers={offers}
        />
      </ModalBody>
    </Modal>
  )
}

ProductOffersModal.propTypes = {
  brand: PropTypes.string,
  offers: PropTypes.arrayOf(PropTypes.shape(ProductOfferShape)).isRequired,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  show: PropTypes.bool,
  onHide: PropTypes.func,
}

ProductOffersModal.defaultProps = {
  brand: undefined,
  show: false,
  onHide: () => {},
}
